/* eslint-disable max-len */
export default [
  {
    id: 'VA0',
    category: 'Risk Assessment and Treatment',
    question: 'Is there a risk assessment program?',
    status: 'Yes',
    comment: ''
  },
  {
    id: 'VA1',
    category: 'Security Policy',
    question: 'Is there an information security policy?',
    status: 'No',
    comment: ''
  },
  {
    id: 'VA2',
    category: 'Security Policy',
    question: 'Is there an Acceptable Use Policy?',
    status: 'No',
    comment: ''
  },
  {
    id: 'VA3',
    category: 'Security Policy',
    question: 'Are any policy(ies) processes) or procedures) communicated to constituents?',
    status: 'No',
    comment: ''
  },
  {
    id: 'VA4',
    category: 'Organizational Security',
    question: 'Is there an information security function responsible for security initiatives within the organization?',
    status: 'No',
    comment: ''
  },
  {
    id: 'VA5',
    category: 'Organizational Security',
    question: 'Is there an individual or group responsible for security within the organization?',
    status: 'No',
    comment: ''
  },
  {
    id: 'VA6',
    category: 'Organizational Security',
    question: 'Does management require the use of confidentiality or non-disclosure agreements?',
    status: 'No',
    comment: ''
  },
  {
    id: 'VA7',
    category: 'Organizational Security',
    question: '​Is access to sensitive data provided to or the processing facilities utilized by external parties?',
    status: 'No',
    comment: ''
  },
  {
    id: 'VA8',
    category: 'Asset Management',
    question: '​Is there an asset management program?',
    status: 'No',
    comment: ''
  },
  {
    id: 'VA9',
    category: 'Asset Management',
    question: 'Are information assets classified?',
    status: 'No',
    comment: ''
  },
  {
    id: 'VA10',
    category: 'Asset Management',
    question: 'Is there insurance coverage for business interruptions or general services interruption?',
    status: 'No',
    comment: ''
  },
  {
    id: 'VA11',
    category: 'Human Resource Security',
    question: '​Are security roles and responsibilities of constituents defined and documented in accordance with the organization\'s information security policy?',
    status: 'Yes',
    comment: ''
  },
  {
    id: 'VA12',
    category: 'Human Resource Security',
    question: '​Are background screenings of applicants performed to include criminal, credit, professional / academic, references and drug screening?',
    status: 'Yes',
    comment: ''
  },
  {
    id: 'VA13',
    category: 'Human Resource Security',
    question: 'Are new hires required to sign any agreements that pertain to non/disclosure, confidentiality, acceptable use or code of ethics upon hire?',
    status: 'Yes',
    comment: ''
  },
  {
    id: 'VA14',
    category: 'Human Resource Security',
    question: 'Is there a security awareness training program?',
    status: 'Yes',
    comment: ''
  },
  {
    id: 'VA15',
    category: 'Human Resource Security',
    question: 'Is there a disciplinarily process for non-compliance with information security policy?',
    status: 'Yes',
    comment: ''
  },
  {
    id: 'VA16',
    category: 'Human Resource Security',
    question: 'Is there a constituent termination or change of status process?',
    status: 'Yes',
    comment: ''
  },
  {
    id: 'VA17',
    category: 'Physical and Environmental Security',
    question: 'Is there a documented physical security policy?',
    status: 'No',
    comment: ''
  },
  {
    id: 'VA18',
    category: 'Physical and Environmental Security',
    question: '​Do the systems storing sensitive data reside in a data center?',
    status: 'No',
    comment: ''
  },
  {
    id: 'VA19',
    category: 'Communications and Operations Management',
    question: '​Are operating procedures utilized?',
    status: 'No',
    comment: ''
  },
  {
    id: 'VA20',
    category: 'Communications and Operations Management',
    question: '​Is there a formal operational change management / change control process?',
    status: 'No',
    comment: ''
  },
  {
    id: 'VA21',
    category: 'Communications and Operations Management',
    question: '​​Is application development performed?',
    status: 'No',
    comment: ''
  },
  {
    id: 'VA22',
    category: 'Communications and Operations Management',
    question: '​Do third party vendors have access to sensitive data (e.g. backup vendors, service providers, equipment support vendors, etc)?',
    status: 'No',
    comment: ''
  },
  {
    id: 'VA23',
    category: 'Communications and Operations Management',
    question: '​Is there a process to review the security of a third party vendor on an ongoing basis?',
    status: 'No',
    comment: ''
  },
  {
    id: 'VA24',
    category: 'Communications and Operations Management',
    question: 'Are system resources reviewed to ensure adequate capacity is maintained?',
    status: 'No',
    comment: ''
  },
  {
    id: 'VA25',
    category: 'Communications and Operations Management',
    question: 'Are criteria for accepting new information systems, upgrades, and new versions established?',
    status: 'Yes',
    comment: ''
  },
  {
    id: 'VA26',
    category: 'Communications and Operations Management',
    question: 'Are anti-virus products used?',
    status: 'Yes',
    comment: ''
  },
  {
    id: 'VA27',
    category: 'Communications and Operations Management',
    question: 'Is there a documented process for securing and hardening network devices?',
    status: 'Yes',
    comment: ''
  },
  {
    id: 'VA28',
    category: 'Communications and Operations Management',
    question: 'Is there wireless networking policy?',
    status: 'Yes',
    comment: ''
  },
  {
    id: 'VA29',
    category: 'Communications and Operations Management',
    question: 'Is all sensitive data encrypted while at rest?',
    status: 'Yes',
    comment: ''
  },
  {
    id: 'VA30',
    category: 'Communications and Operations Management',
    question: 'Is all sensitive data encrypted while at rest?',
    status: 'Yes',
    comment: ''
  },
  {
    id: 'VA31',
    category: 'Communications and Operations Management',
    question: 'Is there a policy that addresses the use and management of removable media? (e.g., CDs, DVDs, tapes, disk drives, etc.)?',
    status: 'Yes',
    comment: ''
  },
  {
    id: 'VA32',
    category: 'Communications and Operations Management',
    question: '​Is Instant Messaging used?',
    status: 'No',
    comment: ''
  },
  {
    id: 'VA33',
    category: 'Communications and Operations Management',
    question: '​Are hardening standards documented?',
    status: 'No',
    comment: ''
  },
  {
    id: 'VA34',
    category: 'Communications and Operations Management',
    question: '​​Are mobile computing devices (Smartphones, Tablets, PDA, etc.) used to store, process or access sensitive data?',
    status: 'No',
    comment: ''
  },
  {
    id: 'VA35',
    category: 'Access Control',
    question: 'Is there an access control policy?',
    status: 'No',
    comment: ''
  },
  {
    id: 'VA36',
    category: 'Access Control',
    question: 'Are unique user IDs used for access?',
    status: 'No',
    comment: ''
  },
  {
    id: 'VA37',
    category: 'Access Control',
    question: 'Are passwords required to access systems holding, processing, or transporting sensitive data?',
    status: 'No',
    comment: ''
  },
  {
    id: 'VA38',
    category: 'Access Control',
    question: '​Is remote access permitted into the environment?',
    status: 'No',
    comment: ''
  },
  {
    id: 'VA39',
    category: 'Access Control',
    question: '​Is there a teleworking policy?',
    status: 'No',
    comment: ''
  },
  {
    id: 'VA40',
    category: 'Information Systems Acquisition Development & Maintenance',
    question: '​Is there a Software Development Life Cycle (SDLC) process?',
    status: 'No',
    comment: ''
  },
  {
    id: 'VA41',
    category: 'Information Systems Acquisition Development & Maintenance',
    question: '​Are the access control procedures the same for both the test and production environment?',
    status: 'Yes',
    comment: ''
  },
  {
    id: 'VA42',
    category: 'Information Systems Acquisition Development & Maintenance',
    question: 'Are systems and applications patched?',
    status: 'Yes',
    comment: ''
  },
  {
    id: 'VA43',
    category: 'Information Systems Acquisition Development & Maintenance',
    question: 'Are vulnerability tests (internal/external) performed on all applications?',
    status: 'Yes',
    comment: ''
  },
  {
    id: 'VA44',
    category: 'Information Systems Acquisition Development & Maintenance',
    question: 'Is there an encryption policy?',
    status: 'Yes',
    comment: ''
  },
  {
    id: 'VA45',
    category: 'Incident Event and Communications Management',
    question: 'Is there an Incident Management program?',
    status: 'Yes',
    comment: ''
  },
  {
    id: 'VA46',
    category: 'Incident Event and Communications Management',
    question: 'Is there an Incident Response Plan?',
    status: 'Yes',
    comment: ''
  },
  {
    id: 'VA47',
    category: 'Business Continuity and Disaster Recovery',
    question: 'Is there a Business Continuity/Disaster Recovery (BC/DR) program?',
    status: 'No',
    comment: ''
  }
]



// WEBPACK FOOTER //
// ./src/components/vendor_assessments/conponents/vendor_questions.js